/* LOGICAZERO — Theme JS */
(function () {
  'use strict';

  /* ── Theme mode toggle ── */
  function initThemeMode() {
    var saved = localStorage.getItem('lz-mode');
    var mode = saved || 'dark';
    document.documentElement.setAttribute('data-mode', mode);

    var toggles = document.querySelectorAll('[data-lz-mode-toggle]');
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var current = document.documentElement.getAttribute('data-mode');
        var next = current === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-mode', next);
        localStorage.setItem('lz-mode', next);
        updateModeButtons(next);
      });
    });
    updateModeButtons(mode);
  }

  function updateModeButtons(mode) {
    document.querySelectorAll('[data-lz-mode-toggle]').forEach(function (btn) {
      btn.textContent = mode === 'dark' ? 'Light' : 'Dark';
    });
  }

  /* ── Nav active link ── */
  function initNav() {
    var links = document.querySelectorAll('.lz-nav__link');
    var current = window.location.pathname;
    links.forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href) return;
      if (href === '/' && current === '/') {
        link.classList.add('is-active');
      } else if (href !== '/' && current.startsWith(href)) {
        link.classList.add('is-active');
      }
    });
  }

  /* ── Product image gallery ── */
  function initGallery() {
    var galleries = document.querySelectorAll('[data-lz-gallery]');
    galleries.forEach(function (gallery) {
      var thumbs = gallery.querySelectorAll('[data-lz-thumb]');
      var main = gallery.querySelector('[data-lz-gallery-main]');
      if (!main) return;

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          var src = thumb.getAttribute('data-src');
          var alt = thumb.getAttribute('data-alt') || '';
          if (src) {
            var img = main.querySelector('img');
            if (img) { img.src = src; img.alt = alt; }
          }
        });
      });
    });
  }

  /* ── Variant selector ── */
  function initVariants() {
    var forms = document.querySelectorAll('[data-lz-variant-form]');
    forms.forEach(function (form) {
      var btns = form.querySelectorAll('.lz-variant-btn');
      var input = form.querySelector('[name="id"]');

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          btns.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (input) input.value = btn.getAttribute('data-variant-id');
          // Update price display
          var price = btn.getAttribute('data-price');
          if (price) {
            var priceEl = form.querySelector('[data-lz-price]');
            if (priceEl) priceEl.textContent = price;
          }
        });
      });
    });
  }

  /* ── Marquee pause on hover ── */
  function initMarquee() {
    var tracks = document.querySelectorAll('.lz-marquee__track');
    tracks.forEach(function (track) {
      var parent = track.closest('.lz-marquee');
      if (!parent) return;
      parent.addEventListener('mouseenter', function () {
        track.style.animationPlayState = 'paused';
      });
      parent.addEventListener('mouseleave', function () {
        track.style.animationPlayState = 'running';
      });
    });
  }

  /* ── FAQ accordion ── */
  function initFaq() {
    var faqs = document.querySelectorAll('.lz-faq');
    faqs.forEach(function (faq) {
      var summary = faq.querySelector('summary');
      var chev = faq.querySelector('.lz-faq__chev');
      if (!summary || !chev) return;
      faq.addEventListener('toggle', function () {
        chev.textContent = faq.open ? '−' : '+';
      });
    });
  }

  /* ── Smooth scroll for anchor links ── */
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var target = e.target.closest('a[href^="#"]');
      if (!target) return;
      var id = target.getAttribute('href').slice(1);
      var el = document.getElementById(id);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  /* ── Scanner telemetry animation ── */
  function initScannerTelemetry() {
    var telemetry = document.querySelectorAll('.lz-scanner__tele em[data-count]');
    if (!telemetry.length) return;

    function randomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    telemetry.forEach(function (el) {
      var base = parseInt(el.getAttribute('data-count') || '0', 10);
      setInterval(function () {
        el.textContent = (base + randomInt(-3, 8)).toString();
      }, 2400 + randomInt(0, 1200));
    });
  }

  /* ── Header cart badge — se met à jour après un ajout au panier AJAX ──
     Le header custom (.lz-nav__cart) n'utilise pas la section Dawn "cart-icon-bubble"
     que cart-drawer.js essaie de remplacer automatiquement ; on écoute donc directement
     l'événement pub/sub "cart-update" que Dawn publie déjà (product-form.js) et on
     recharge /cart.js pour avoir le compte réel. */
  function initCartBadge() {
    var link = document.querySelector('.lz-nav__cart');
    var countEl = document.querySelector('.lz-nav__cart-count');
    if (!link || !countEl) return;

    function render(count) {
      countEl.textContent = String(count).padStart(2, '0');
      link.setAttribute('aria-label', 'Cart (' + count + ' items)');
    }

    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) { render(cart.item_count); })
        .catch(function () {});
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
    document.addEventListener('cart:refresh', refresh);
  }

  /* ── Feedback de survol garanti sur les boutons secondaires (.lz-btn-arrow) ──
     Appliqué directement en style inline via JS pour ne dépendre d'aucune règle CSS
     externe : garantit un changement visible même en cas de conflit de cascade. */
  function initSecondaryButtonHover() {
    var buttons = document.querySelectorAll('.lz-btn-arrow');
    buttons.forEach(function (btn) {
      var icon = btn.querySelector('.lz-btn-arrow__icon');
      btn.addEventListener('mouseenter', function () {
        btn.style.borderColor = 'var(--accent-light, #DED4C8)';
        btn.style.backgroundColor = 'var(--glass-2, rgba(255,255,255,0.08))';
        btn.style.color = 'var(--accent-light, #DED4C8)';
        btn.style.transform = 'translateY(-2px)';
        if (icon) icon.style.transform = 'translateX(8px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.borderColor = '';
        btn.style.backgroundColor = '';
        btn.style.color = '';
        btn.style.transform = '';
        if (icon) icon.style.transform = '';
      });
    });
  }

  /* ── Init all ──
     Chaque init est isolé dans un try/catch : si l'un plante (élément absent sur une page
     donnée, etc.), les suivants continuent quand même à s'exécuter au lieu d'être bloqués. */
  function safeInit(fn) {
    try { fn(); } catch (e) { if (window.console) console.error('[LOGICAZERO]', fn.name, e); }
  }

  document.addEventListener('DOMContentLoaded', function () {
    safeInit(initSecondaryButtonHover);
    safeInit(initThemeMode);
    safeInit(initNav);
    safeInit(initGallery);
    safeInit(initVariants);
    safeInit(initMarquee);
    safeInit(initFaq);
    safeInit(initSmoothScroll);
    safeInit(initScannerTelemetry);
    safeInit(initCartBadge);
    /* Animations are handled entirely by lz-premium-animations.js */
  });

})();



